import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function FooterAtoutFranceLogoIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.06967 11.1432L1.87109 11.6615H3.31598L3.11906 11.1432H2.06967Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M0.953613 5.16675V11.6635H1.12521L2.19258 9.10261H2.99807L4.06251 11.6635H4.23411V5.16675H0.953613Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.24121 10.6974H2.95273L2.59872 9.76147L2.24121 10.6974Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.2726 13.9274L9.91671 12.9883L9.55737 13.9274H10.2726Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.3177 12.3226L11.3887 14.8961H10.6388L10.4402 14.3742H9.38755L9.18568 14.8961H8.43653L9.50849 12.3226H8.27319V18.8333H11.5511V12.3226H10.3177Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.64167 9.72401H7.75672V11.6673H7.03437V9.72401H6.14941V9.10278H8.64167V9.72401Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.3734 10.3796C13.3734 11.1634 12.8317 11.6943 12.0027 11.6943C11.0509 11.6943 10.6338 11.0298 10.6338 10.3796C10.6338 9.54345 11.2297 9.06665 12.0027 9.06665C12.9148 9.06665 13.3734 9.66989 13.3734 10.3796ZM12.6311 10.3796C12.631 10.2546 12.5939 10.1324 12.5244 10.0285C12.4549 9.92461 12.3561 9.84366 12.2406 9.79588C12.1251 9.7481 11.998 9.73565 11.8754 9.7601C11.7528 9.78454 11.6402 9.84478 11.5519 9.93321C11.4635 10.0216 11.4034 10.1343 11.3791 10.2569C11.3547 10.3795 11.3673 10.5066 11.4152 10.622C11.463 10.7375 11.5441 10.8362 11.648 10.9056C11.752 10.975 11.8742 11.012 11.9992 11.012C12.1668 11.0118 12.3274 10.9451 12.4458 10.8265C12.5642 10.7079 12.6306 10.5472 12.6305 10.3796H12.6311Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M18.2659 10.5159C18.2659 11.2961 17.7241 11.6971 16.9926 11.6971C16.2611 11.6971 15.7158 11.3062 15.7158 10.5159V9.10278H16.4389V10.3164C16.4389 10.7552 16.6015 11.0533 16.9807 11.0533C17.3598 11.0533 17.5224 10.7824 17.5224 10.3192V9.10278H18.2448L18.2659 10.5159Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M23.0555 9.72401H22.1705V11.6673H21.4482V9.72401H20.5632V9.10278H23.0555V9.72401Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.90234 13.8552H1.89443V14.8972H1.16309V12.3237H2.90234V12.8401H1.89443V13.3386H2.90216L2.90234 13.8552Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.96221 14.8974H6.17617L5.98476 14.4404C5.93728 14.314 5.87676 14.193 5.80417 14.0792C5.76741 14.0178 5.71389 13.9683 5.64991 13.9363C5.58593 13.9043 5.51414 13.8912 5.443 13.8986H5.35986V14.9027H4.61255V12.3238H5.85868C5.96816 12.3164 6.078 12.3315 6.18141 12.3682C6.28481 12.405 6.37957 12.4625 6.45983 12.5374C6.54008 12.6122 6.60412 12.7027 6.64798 12.8033C6.69185 12.9039 6.71459 13.0124 6.71482 13.1221C6.72136 13.2568 6.68689 13.3903 6.61594 13.505C6.545 13.6197 6.44093 13.7102 6.31749 13.7645C6.5089 13.8819 6.57571 14.0082 6.71849 14.3387L6.96221 14.8974ZM5.96714 13.1364C5.96714 12.907 5.84069 12.8167 5.4975 12.8167H5.34408V13.436H5.50117C5.83519 13.4382 5.96714 13.3875 5.96714 13.1364Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.7411 14.8972H15.0909L13.8266 13.4634V14.8974H13.1042V12.3237H13.7545L15.0188 13.7504V12.3237H15.7411V14.8972Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.5751 14.7041C19.2806 14.8616 18.9501 14.9394 18.6162 14.9299C17.7133 14.9299 17.2437 14.3426 17.2437 13.6085C17.2437 12.6784 17.919 12.2882 18.6271 12.2882C18.9485 12.2974 19.2659 12.3635 19.5643 12.4833V13.1678C19.4497 13.0917 19.3291 13.025 19.2037 12.9685C19.073 12.9131 18.932 12.8861 18.79 12.8891C18.6894 12.8817 18.5883 12.8948 18.4928 12.9274C18.3974 12.9601 18.3095 13.0117 18.2344 13.0792C18.1594 13.1466 18.0987 13.2285 18.0561 13.32C18.0135 13.4114 17.9898 13.5106 17.9864 13.6114C17.9877 13.709 18.0087 13.8053 18.0483 13.8945C18.0878 13.9836 18.145 14.0639 18.2164 14.1304C18.2878 14.1969 18.3719 14.2482 18.4637 14.2813C18.5555 14.3144 18.653 14.3286 18.7504 14.3229C18.959 14.3219 19.1644 14.2716 19.35 14.1761C19.4264 14.1364 19.5005 14.0924 19.572 14.0444L19.5751 14.7041Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M23.0556 14.8972H21.217V12.3237H23.0231V12.8401H21.9539V13.3114H22.9724V13.8333H21.9539V14.3751H23.055L23.0556 14.8972Z"
				fill="currentColor"
			/>
		</svg>
	);
}

FooterAtoutFranceLogoIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default FooterAtoutFranceLogoIcon;
